module.exports = require("react-tagsinput");